export const pdfOptions = {
    wasmUrl: '/pdfjs/wasm/',
    iccUrl: '/pdfjs/iccs/',
    // PDF.js loads ICC colour profiles in the worker.
    useWorkerFetch: true,
}
